import type { DialogType } from '../../../@types';
import type { GgaFreeSpinsFilters } from '../../../@types/casino';
import { QUERY_KEYS } from '../../../constants';
import { prepareGgaFreeSpinsFilters } from '../../../helpers/casino';
import useFilterForm from '../../../hooks/useFilterForm';
import type { AdditionalQueryParams } from '../../../hooks/usePagination';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import CustomerSelect from '../../molecules/CustomerSelect';

const DEFAULT_FORM_DATA: GgaFreeSpinsFilters = {
  playerIds: undefined,
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterCasinoFreeSpins = ({ changeQuery, closeModal }: Props) => {
  const { control, handleResetFilter, handleSubmit } = useFilterForm<GgaFreeSpinsFilters>({
    defaultData: DEFAULT_FORM_DATA,
    changeQuery,
    prepareQueryParams: prepareGgaFreeSpinsFilters,
  });

  return (
    <FilterDialogLayout
      label='free spins'
      onSave={handleSubmit}
      onClose={() => closeModal?.()}
      onReset={handleResetFilter}
    >
      <CustomerSelect
        control={control}
        name='playerIds'
        label='Player'
        queryKey={[QUERY_KEYS.customers, 'gga-free-spins-filter-players']}
        queryParams={{ filters: { isActive: true } }}
      />
    </FilterDialogLayout>
  );
};

export default FilterCasinoFreeSpins;
